module.exports = __webpack_public_path__ + "img/licores.95e7cccf.jpg";